import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldAlert, Mail } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const absUrl = (p) => (p && !/^https?:/i.test(p) ? `${BACKEND_URL}${p}` : p);
const isEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

export default function AccessDenied() {
  const [info, setInfo] = useState({
    ip: "",
    denied_title: "Accès refusé",
    denied_subtitle: "Votre IP n'est pas autorisée",
    denied_message:
      "L'accès à ce portail est restreint à une liste d'adresses IP autorisées par l'administrateur.",
    denied_show_ip: true,
    denied_contact: "",
    site_title: "NetKom Portal",
    site_logo_path: "",
    bg_image_path: "",
    denied_bg_image_path: "",
    brand_color: "#002FA7",
  });

  useEffect(() => {
    api
      .get("/access/check")
      .then(({ data }) => setInfo((prev) => ({ ...prev, ...data })))
      .catch(() => {});
  }, []);

  const bgPath = info.denied_bg_image_path || info.bg_image_path;
  const bgStyle = bgPath
    ? {
        backgroundImage: `linear-gradient(180deg, hsla(0,0%,100%,0.86) 0%, hsla(0,0%,100%,0.96) 100%), url(${absUrl(bgPath)})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }
    : undefined;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4" style={bgStyle}>
      <div className="max-w-md w-full text-center" data-testid="access-denied-container">
        {info.site_logo_path ? (
          <img
            src={absUrl(info.site_logo_path)}
            alt={info.site_title}
            className="h-14 mx-auto mb-5 object-contain"
          />
        ) : (
          <div
            className="inline-flex h-16 w-16 items-center justify-center rounded-sm text-white mb-6"
            style={{ backgroundColor: info.brand_color }}
          >
            <ShieldAlert className="h-8 w-8" />
          </div>
        )}
        <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground mb-2">
          403 — {info.denied_title}
        </p>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight leading-none mb-4" data-testid="access-denied-subtitle">
          {info.denied_subtitle}
        </h1>
        <p className="text-muted-foreground mb-2 whitespace-pre-wrap" data-testid="access-denied-message">
          {info.denied_message}
        </p>
        {info.denied_show_ip && info.ip && (
          <p className="text-sm text-muted-foreground mt-3" data-testid="access-denied-ip">
            Votre IP : <span className="font-mono text-foreground">{info.ip}</span>
          </p>
        )}
        {info.denied_contact && (
          <p className="mt-4" data-testid="access-denied-contact">
            {isEmail(info.denied_contact) ? (
              <a
                href={`mailto:${info.denied_contact}`}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-sm text-sm font-medium text-white"
                style={{ backgroundColor: info.brand_color }}
              >
                <Mail className="h-4 w-4" /> Contacter l&apos;administrateur
              </a>
            ) : (
              <strong>{info.denied_contact}</strong>
            )}
          </p>
        )}
        <a
          href="/admin/login"
          className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-sm border border-border bg-background hover:bg-accent text-sm font-medium"
          data-testid="access-denied-admin-link"
        >
          Connexion administrateur
        </a>
      </div>
    </div>
  );
}
